export default "__VITE_ASSET__C0ppC$R0__"